import { flexRender, HeaderGroup, RowModel } from "@tanstack/react-table";
import { RouteProperties } from "../RouteProperty";

interface Props {
  heading: HeaderGroup<any>[];
  body: RowModel<any>;
}

export const Table = ({ body, heading }: Props) => {
  return (
    <div className="w-[calc(100vw_-_3rem)] md:w-full overflow-auto">
      <table className="w-full">
        <thead>
          {heading.map((itm) => (
            <tr
              key={itm.id}
              className="border text-xs font-medium text-gray-600 bg-gray-100"
            >
              {itm.headers.map((head) => (
                <th key={head.id} className="py-3 px-6 text-left">
                  {flexRender(head.column.columnDef.header, head.getContext())}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody className="border">
          {body.rows.map((row) => (
            <>
              <tr key={row.id} className="border-b">
                {row.getVisibleCells().map((cell) => (
                  <td key={cell.id} className="px-6 py-7">
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>

              {row.getIsExpanded() ? (
                <tr className="border-b">
                  <RouteProperties public_id={row.original.public_id} />
                </tr>
              ) : null}
            </>
          ))}
        </tbody>
      </table>
    </div>
  );
};
